var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrowse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6h2M2 18h2M6 6h14M6 18h14M4 12h2m2 0h14",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E %3Cg fill='none' fill-rule='evenodd' stroke-width='2'%3E %3Cpath d='M0 1L2 1M0 13L2 13M4 1L18 1M4 13L18 13M2 7L4 7M6 7L20 7' transform='translate(2 5)'/%3E %3C/g%3E %3C/svg%3E";
export { SvgBrowse as ReactComponent };